import { LogOutIcon, VenetianMask } from 'lucide-react'
import { account } from '../classes/Account'

export default function ImpersonationBar({ applicationId }) {
  return (
    <div className='w-full flex items-center justify-between bg-amber-400 dark:bg-amber-600/20 shadow-sm border-b border-amber-500/20 dark:border-amber-600/30 px-6 py-3 transition-colors duration-300 z-50'>
      <div className='flex items-center gap-3'>
        <div className='flex items-center justify-center bg-amber-500 dark:bg-amber-500/30 text-white dark:text-amber-400 rounded-full w-8 h-8 shadow-sm'>
          <VenetianMask size={16} />
        </div>
        <div className='flex flex-col'>
          <span className='text-xs font-bold text-amber-900 dark:text-amber-400 uppercase tracking-wider'>Impersonation Mode Active</span>
          <span className='text-sm font-medium text-amber-800 dark:text-amber-500/90'>Currently viewing as: <strong className='text-amber-900 dark:text-amber-300'>{account.name}</strong></span>
        </div>
      </div>

      <button
        onClick={() => window.location.href = `https://myportal.ertcrefund.com/team/applications/${applicationId}/contact`}
        className='flex items-center gap-2 px-4 py-1.5 bg-amber-900/10 hover:bg-amber-900/20 dark:bg-amber-500/10 dark:hover:bg-amber-500/20 text-amber-900 dark:text-amber-400 rounded-xl text-sm font-semibold transition-all duration-200 active:scale-95 border border-amber-900/10 dark:border-amber-500/20 backdrop-blur-sm'
      >
        <LogOutIcon size={16} />
        Exit Impersonation
      </button>
    </div>
  )
}